<app-shippingcalculator></app-shippingcalculator>
<div id="backdrop" class="modal-backdrop fade" [ngClass]="{ show: showModal }"></div>
    <div class="modal d-block fade" 
      [ngClass]="{ show: showModal }"
      (click)="onClose()"
      id="listing-dialog" 
      tabindex="-1" role="dialog" aria-labelledby="modalIdLabel">
        <div class="modal-dialog modal-lg" role="document" (click)="onDialogClick($event)">
            <div class="modal-content">
                <div class="modal-header">
                    <h5>yourDesiCart Rates
                    </h5>
                    <button type="button"
                        class="close"
                        (click)="onClose()"
                        aria-label="Close"><span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                  <table width="100%" border="1">
                      <thead>
                         <th>Title</th>
                         <th>Price</th>
                      </thead>
                      <tbody>
                          <tr style="background-color:whitesmoke;">
                              <td>Estimated Shipping Price</td>
                              <td><b>INR {{price}}</b></td>
                          </tr>
                          <tr>
                            <td>Shipper Name</td>
                            <td><b>DHL</b></td>
                        </tr>
                        <tr style="background-color:whitesmoke;">
                            <td>Weight in kg</td>
                            <td><b>{{weight}} Kg</b></td>
                        </tr>
                      </tbody>
                  </table>
                  <span>Includes yourDesiCart Base Charge Rs.750 -  free locker storage for 30 days, faults inspection, eligibility checks, item photos, domestic returns, consolidation, efficient packing, customs paperwork, and Express shipping 3-7 day deliveries</span><br><br>
                  <div align="right" class="highlight">
                   
                    <div class="test_view_more_btn_container"
                        style="margin-top:-45px;">
                        <span style="font-size: 14px;color:  grey;">
                          Love Our Rates?</span>&nbsp;&nbsp;
                        <a href="https://forms.gle/XReb2rJ9GCw3EZAJ7" target="_blank"><button
                                class="test_view_more_btn">SIGNUP NOW!</button></a>
                    </div>
                </div>
                 
                  <b>Important information to consider before using our services.</b>
                  <ol style="margin-top:10px;" role="tablist" class="ui-tabs-nav ui-corner-all ui-helper-reset ui-helper-clearfix ui-widget-header">
                 <!--    <b><li>COVID-19 Emergency Situation Charges:</li></b>
                    <span>Given the significant impacts of COVID-19 on the global aviation industry shipping companies are charging the Emergency Situation Charges to maintain reliable and high-quality delivery services.</span><br><br>
                    <span>Emergency Situation Surcharge as of August 24, 2020. (These charges will be reviewed regularly)</span><br><br>
                    <span>COVID Emergency charges will be applied on top of the shipping charges as below. (Charge in INR per kg):</span><br><br>
                    
                    <table class="table-responsive" style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;margin-bottom:20px;">
                        <tbody><tr>
                          <th style="border: 1px solid #dddddd;text-align: left;padding: 8px;">Origin/Destination</th>
                          <th style="border: 1px solid #dddddd;text-align: left;padding: 8px;">China</th>
                          <th style="border: 1px solid #dddddd;text-align: left;padding: 8px;">Hongkong/Macau</th>
                        
                          <th style="border: 1px solid #dddddd;text-align: left;padding: 8px;">Australia &amp; Newzeland</th>
                          <th style="border: 1px solid #dddddd;text-align: left;padding: 8px;">Rest of world</th>
                          <th style="border: 1px solid #dddddd;text-align: left;padding: 8px;">Asia	</th>
                      </tr>
                      <tr>
                          <td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">India (Price INR per kg)</td>
                          <td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">105</td>
                          <td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">105</td>
                          
                          <td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">235</td>
                          <td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">25</td>
                          <td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">105</td>
                      </tr>
                      <tr>
                        <td colspan="6">
                           <b></b><b style="color: red;font-size: 16px;"><p>Note: &nbsp;Read All Covid-19 Surcharges and Customs/Duties Points.</p></b>
                        </td>
                      </tr>
                  </tbody></table> -->
                    <b><li>Shipping Charges:</li></b>
                    <span>Shipment charges are calculated according to the higher of actual or volumetric weight per piece.The price shown above is to ship your parcel from our warehouse in India to your destination address.</span><br><br>
                    <b><li>Fuel Surcharges &amp; IGST(Tax) within India</li></b>
                    <span>The shipping rates displayed are inclusive of the fuel surcharge and taxes within India.</span><br><br>
                    <b><li>Estimated Delivery Timeline:</li></b>
                    <span>5-7 working days (subject to customs clearance)</span><br><br>
                    <b><li>Duties / VAT / Clearance Charges / Admin Charges at Destination:</li></b>
                    <span>Shipping price does not include Duty/VAT or any clearance/admin charges imposed at Destination. If any imposed receiver is liable to pay.</span><br><br>
                    <b><li>Commercial Shipment Clearance:</li></b>
                    <span>For shipment values greater than INR 25000, clearance charges of INR 4000 will be applicable on addition to the shipping charges shown above.</span><br><br>
                    <b><li>Remote Area Charges:</li></b>
                    <span>Surcharge of INR 3045 applies when a shipment is delivered to a location that is distant or difficult to serve. Remote area postcodes will be considered as listed by DHL and FedEx.</span><br><br>
               
                  <b><li>OVERSIZE PIECE (DIMENSION):</li></b>
                  <span>Any single piece in a shipment that exceeds the dimension of 120 cm, at which threshold all such pieces require
                    non-standard procedures and resources to be handled.</span><br>
                    <span>rate per piece INR 8,500</span><br><br>
                    <span></span>
                    <b><li>Cannot ship to:</li></b>
                    <span>Afghanistan, Iraq, Libya, Mali, Niger, Sudan, Syria and Yemen, (Central African Republic, Democratic Republic of Congo, Iran, Iraq, North Korea, Libya, Somalia, Syria</span><br><br>
                    <b><li>Upto 70 kgs including packing allowed in one shipment via air</li></b>
                  </ol>
                </div>
                <!-- <div class="modal-footer">
                  <button type="button" class="btn btn-primary" (click)="onClose()">Close</button>
                </div> -->
            </div>
        </div>
    </div>